import { IInference, IAstNode } from './typings';
import { TypeGenerator } from '../utils/type';
import { isDateTimeLike, isDigit } from '../utils/type';
import { InferenceError } from '../errors';



// 大于/小于/
export function inferenceSizeComparison(inference: IInference, astNode: IAstNode) {
  const operator = astNode.operator!;
  const isManyToOne = operator.startsWith('ALL-') || operator.startsWith('ANY-');

  const leftType = inference(astNode.left)!;
  const rightType = inference(astNode.right)!;
  const token = astNode.token;


  function error(message: string) {
    return new InferenceError('comparison-value-error', message, token.position);
  }

  if (isManyToOne) {
    if (!leftType.isArray) {
      throw error(`比较符左侧必须为数组类型`);
    }

    if (rightType.isArray) {
      throw error(`比较符右侧不能为数组类型`);
    }

  } else if (leftType.isArray) {
    throw error(`比较符左侧不能为数组类型`);
  }

  if (!isDigit(leftType) && !isDateTimeLike(leftType)) {
    throw error('非数字或日期时间类型不能参与比较');
  }

  if (!isDigit(rightType, false) && !isDateTimeLike(rightType, false)) {
    throw error('非数字或日期时间类型不能参与比较');
  }

  if (isDigit(leftType) && isDigit(rightType, false)) {
    return TypeGenerator.Boolean();
  }

  if (isDateTimeLike(leftType) && isDateTimeLike(rightType, false) && leftType.type === rightType.type) {
    return TypeGenerator.Boolean();
  }

  throw error('比较符两侧的数据类型不匹配');
}
